/* eslint-disable */
export default {
  cancel: 'Annuler',
  pmiChangeConfirmed: 'Changer',
  pmiChangeConfirmTitle: 'Changer les paramètres de la réunion personnelle?',
  pmiChangeConfirmContext:
    'Le changement de ces paramètres aura une incidence sur toutes les réunions qui utilisent votre code ou votre nom de réunion personnelle, y compris celles qui sont déjà planifiées.',
  updatePassword: 'Mettre à jour le mot de passe',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"pmiChangeConfirmed"@#@ @source: @#@"Change"@#@
// @key: @#@"pmiChangeConfirmTitle"@#@ @source: @#@"Change Personal Meeting settings?"@#@
// @key: @#@"pmiChangeConfirmContext"@#@ @source: @#@"Changing these settings will affect all meetings that use your personal meeting ID or name, including those you've already scheduled"@#@
// @key: @#@"updatePassword"@#@ @source: @#@"Update password"@#@
